import _ from "lodash";
import React, { Component } from "react";
import Booth from "./booth";
import RndBooth from "./rndbooth";
import ResizableBooth from "./resizablebooth";
import {
  addNewBooth,
  addInteractiveMapName,
  mapImageChanged,
  uploadNewiMapImage,
  imapImageToUpload,
  startFileUpload,
  addBoothData,
  closeBooth,
} from "InteractiveMapAction";
import { connect } from "react-redux";
import Dropzone from "react-dropzone";
import {
  IMAGE_PATH,
  BASE_IMAGES_URL,
  ACCESS_FILES_API_KEY,
  NEW_IMAGE_PATH,
} from "Constants";
import { randomstring } from "randomstring-js";
import { MapInteractionCSS } from "react-map-interaction";
import LocaleStrings from "Languages";

var ZOOM_LEVEL = {
  MIN: 1,
  MAX: 2,
};

interface Offset {
  x: number;
  y: number;
}

var VISIBLE_INDICATORS_COUNT = 8;

var OFFSET_DEFAULT = {
  x: 0,
  y: 0,
};

var imageOuter;
var imageComponent;
var draggable;
var src;
var clientOffset;
var offsetRange;
var mounted;
var defaultScaleDiff = 1;

class IMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accept: "image/jpeg, image/png",
      file: {},
      defaultImageSize: {
        minWidth: 400,
        minHeight: 400,
        maxWidth: 2000,
        maxWidth: 2000,
      },
      loadedImageSize: { width: 0, height: 0 },
      imagePreviewUrl: "",
      mapImageToBeAdded: true,
      booths: [],
      zoom: ZOOM_LEVEL.MIN,
      scale: 1,
      offset: OFFSET_DEFAULT,
      onload: false,
      loading: false,
      locationOffset: { x: 0, y: 0 },
      showImageError: false,
      imageJustAdded: false,
      toAddNewBooth: false,
      boothToBeAdded: {},
      scale: 1,
      translation: { x: 0, y: 0 },
    };
    draggable = false;
    offsetRange = OFFSET_DEFAULT;
    clientOffset = {
      x: undefined,
      y: undefined,
    };
  }

  onDrop(files) {
    this.setState({ imageJustAdded: true });
    let reader = new FileReader();
    let file = files[0];

    if (file && file.type.indexOf("image") !== -1) {
      this.props.startFileUpload();

      //Determine if it is a valid file...
      var uploadedimage = new Image();
      uploadedimage.addEventListener("load", () => {
        if (uploadedimage.width < this.state.defaultImageSize.minWidth) {
          this.setState({ showImageError: true });
          setTimeout(() => {
            this.setState({ showImageError: false });
          }, 3000);
          return;
        }
        if (uploadedimage.height < this.state.defaultImageSize.minHeight) {
          this.setState({ showImageError: true });
          setTimeout(() => {
            this.setState({ showImageError: false });
          }, 3000);
          return;
        }

        // & max size upto 2000 * 2000
        if (uploadedimage.width > this.state.defaultImageSize.maxWidth) {
          this.setState({ showImageError: true });
          setTimeout(() => {
            this.setState({ showImageError: false });
          }, 3000);
          return;
        }

        if (uploadedimage.height > this.state.defaultImageSize.maxHeight) {
          this.setState({ showImageError: true });
          setTimeout(() => {
            this.setState({ showImageError: false });
          }, 3000);
          return;
        }

        reader.onloadend = () => {
          this.loadImage(reader.result);
          var filename = randomstring(32);
          var imageData = {
            imagefile: reader.result,
            filename: filename,
            interactivemapid: this.props.selectedMap.interactivemapid,
          };
          this.props.imapImageToUpload(imageData);
          this.props.uploadNewiMapImage(imageData, this.props.session);
        };
        reader.readAsDataURL(file);
      });

      uploadedimage.src = window.URL.createObjectURL(file);
    } else {
      //this.setState({imageErrorClsName: 'alert-danger',imageErrorMsg:'Please choose an image', imagePreviewUrl: IMAGE_PATH + 'placeholder_600x400.svg'});
    }
  }

  applyMimeTypes(event) {
    this.setState({
      accept: event.target.value,
    });
  }

  renderBooths() {
    var { locationOffset } = this.state;
    var items = this.props.booths.map((booth) => (
      // <RndBooth
      //   key={booth.locationid}
      //   offset={locationOffset}
      //   booth={booth}
      // />
      // <Booth
      //       key={booth.locationid}
      //       offset={locationOffset}
      //       booth={booth}
      // />
      <ResizableBooth
        key={booth.locationid}
        offset={locationOffset}
        booth={booth}
      />
    ));

    if (
      this.props.boothToBeAdded &&
      !this.objectIsEmpty(this.props.boothToBeAdded)
    ) {
      items.push(
        // <RndBooth
        //   key={this.props.boothToBeAdded.locationid}
        //   offset={locationOffset}
        //   booth={this.props.boothToBeAdded}
        // />
        // <Booth
        //     key={this.props.boothToBeAdded.locationid}
        //     offset={locationOffset}
        //     booth={this.props.boothToBeAdded}
        // />
        <ResizableBooth
          key={this.props.boothToBeAdded.locationid}
          offset={locationOffset}
          booth={this.props.boothToBeAdded}
        />
      );
    }

    return items;
  }

  loadImage(src: string) {
    //debugger;
    if (src.length > 0) {
      this.setState({ imagePreviewUrl: src });
      this.setState({ mapImageToBeAdded: false });
      if (!this.props.uploadInProcess) this.props.imageCallback(); //Notifiy the parent component that image has been loaded...

      if (this.props.changeMapImage) {
        this.props.mapImageChanged();
      }
    }
    this.setState({ loading: true });

    var img = new Image();
    img.src = src;

    img.onload = () => {
      if (!src) return;
      this.setState({ loading: false, onload: true });
      // this.setOffsetRange();
      this.setState({
        loadedImageSize: { width: img.width, height: img.height },
      });
    };
    img.onerror = () => {
      if (!src) return;
      this.setState({ loading: false, onload: false });
    };
  }

  _onMouseDown(e) {
    if (this.props.uploadInProcess || this.props.uploadFailed) return;
    if (draggable) {
      // old codes onMoveEnd(e);
      return;
    }
    if (!this.state.onload) return;
    if (e.target.className === "map-image") {
      //Add location points only on Image
      /*var boothid = _.uniqueId("booth-");
      //var booths=this.state.booths;
      var newbooth={locationid:boothid,location_x: e.clientX-100,location_y:e.clientY-100,color:defaultBoothColor,boothno:''};
      //this.setState({booths:[...booths,newbooth]});
      this.props.addNewBooth(newbooth);
      this.setState({toAddNewBooth:true});*/
    }
  }

  refreshBooths() {
    // var booths=this.state.booths;
    // this.setState({booths:[...booths]});
  }

  onZoomOut(e) {
    if (!this.state.onload) return;
    if (this.state.zoom === ZOOM_LEVEL.MIN) return;
    var zoomLevel = Math.max(ZOOM_LEVEL.MIN, this.state.zoom - 1);
    // this.setState({scale: this.state.scale-defaultScaleDiff});
    this.setState({ zoom: "100%" });
    // this.setOffsetRange();
  }

  onZoomIn(e) {
    if (!this.state.onload) return;
    if (this.state.zoom === ZOOM_LEVEL.MAX) return;
    var zoomLevel = Math.min(this.state.zoom + 1, ZOOM_LEVEL.MAX);
    this.setState({ scale: this.state.scale + defaultScaleDiff });
    this.setState({ zoom: "200%" });
    //this.setOffsetRange();
  }

  componentWillReceiveProps(nextProps: any) {
    if (this.props.image.src != nextProps.image.src) {
      this.setState({ imageJustAdded: false });
    }
    if (nextProps.changeMapImage) {
      //User might have requested for map change...
      this.setState({ mapImageToBeAdded: true });
      this.loadImage("");
    }
  }

  componentDidMount() {
    this.setState({ booths: this.props.booths });
    mounted = true;
    this.loadImage(this.props.image.src);
  }

  componentWillUnmount() {
    mounted = false;
    if (!!src) {
      src = undefined;
    }
  }

  objectIsEmpty(object) {
    return Object.keys(object).length === 0 && object.constructor === Object;
  }

  render() {
    var {
      offset,
      zoom,
      imagePreviewUrl,
      showImageError,
      imageJustAdded,
      scale,
      translation,
    } = this.state;
    var value = ""; //!this.state.mapImageToBeAdded ? `scale3d(${(zoom === ZOOM_LEVEL.MIN)?ZOOM_LEVEL.MIN:(zoom-1)+defaultScaleDiff}, ${(zoom === ZOOM_LEVEL.MIN)?ZOOM_LEVEL.MIN:(zoom-1)+defaultScaleDiff}, 1) translate3d(${offset.x}px, ${offset.y}px, 0px)` : '';
    var imageCls = `image-outer`;
    var dragCls = `drag-icon ${draggable ? "visible" : ""}`;

    var { accept } = this.state;
    const mapImage = {
      //display: "inline - block",
      //verticalAlign: "middle",
      position: "absolute",
      height: "600px",
      width: "600px",
      objectFit: "contain",
    };
    var borderCss = `1px dashed ${showImageError ? "#f73c3c" : "#4da1ff"}`;
    var scaleValue = this.state.scale;
    var overlayStyle = {
      width: "100%",
      height: "85%",
      padding: "2.5em 0",
      textAlign: "center",
      border: borderCss,
      background: "white",
      borderRadius: 5,
    };

    var scaling = `scale3d(${scaleValue},${scaleValue},${scaleValue})`;
    var zoomStyle = { zoom: this.state.zoom };
    var dropzoneText = (
      <div>
        {LocaleStrings.imap_draganddrop}
        <br /> {LocaleStrings.imap_maintain}{" "}
        <span className="select-file">{LocaleStrings.imap_400X400}</span>
        {LocaleStrings.imap_resolution}
        <br /> {LocaleStrings.imap_maxmaintain}
        <span className="select-file">{LocaleStrings.imap_2000X2000}</span>
      </div>
    );
    var dropzoneCss = "drop-text imap-drop-text";

    if (showImageError) {
      dropzoneText = (
        <div>
          {LocaleStrings.imap_addatleast}
          <br />{" "}
          <span className="select-file">{LocaleStrings.imap_400X400}</span>{" "}
          {LocaleStrings.imap_resolution}
          <br /> {LocaleStrings.imap_maxmaintain}
          <span className="select-file">{LocaleStrings.imap_2000X2000}</span>
        </div>
      );
      dropzoneCss = "drop-text imap-drop-text upload-error";
    }

    return (
      <div>
        {this.state.mapImageToBeAdded ? (
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="dropzone imap-dropzone">
                <Dropzone accept={accept} onDrop={this.onDrop.bind(this)}>
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} style={overlayStyle}>
                      <input {...getInputProps()} />
                      <div
                        className="drop-text"
                        style={{ paddingTop: 130, paddingBottom: 130 }}
                      >
                        <div>
                          <img src={`${NEW_IMAGE_PATH}picture.png`} />
                        </div>
                        <div style={{ color: "#a2a3b1" }}>{dropzoneText}</div>
                      </div>
                    </div>
                  )}
                </Dropzone>
              </div>
            </div>
            <div className="col-md-2"></div>
          </div>
        ) : (
          <div className="react-image-viewer">
            <div className="imgmapwrap" style={zoomStyle}>
              <div
                style={{
                  width: "610px",
                  height: "610px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                <MapInteractionCSS
                  minScale={0.8}
                  maxScale={5}
                  scale={scale}
                  translation={translation}
                  onChange={({ scale, translation }) =>
                    this.setState({ scale, translation })
                  }
                >
                  <img
                    style={mapImage}
                    src={imagePreviewUrl}
                    ref={(component: any) => (imageComponent = component)}
                  />
                  {this.renderBooths()}
                </MapInteractionCSS>
              </div>
            </div>
            {this.state.mapImageToBeAdded ||
            imageJustAdded ||
            this.props.uploadInProcess ||
            this.props.uploadFailed ? (
              ""
            ) : (
              <div
                className="tool-bar"
                style={{
                  lineHeight: 1,
                  paddingLeft: "15px",
                  fontWeight: "bold",
                  color: "#4da1ff",
                }}
              >
                Scroll mouse for zooming in and out
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function objectIsEmpty(object) {
  return Object.keys(object).length === 0 && object.constructor === Object;
}

function mapStateToProps(state, ownProps) {
  var imageSrc = "";
  if (state.selectediMap.mapfilepath.length > 0)
    imageSrc = `${BASE_IMAGES_URL}/${state.selectediMap.mapfilepath}?api_key=${state.session.apiKey}&session_token=${state.session.sessionToken}`;

  var booths = [];
  if (
    state.selectediMap &&
    state.selectediMap.interactivemap_locations_by_interactivemapid
  )
    booths = state.selectediMap.interactivemap_locations_by_interactivemapid;

  var activeBooth = state.activelyUpdatedBooth.payload;
  var toAddNewBooth = state.addEditBooth.toAddNewBooth;
  var boothToBeAdded = state.boothToAdd;

  if (activeBooth && !objectIsEmpty(activeBooth)) {
    if (toAddNewBooth) {
      var newBoothUpdated = {};
      if (!objectIsEmpty(boothToBeAdded))
        newBoothUpdated = { ...boothToBeAdded, color: activeBooth.color };
      boothToBeAdded = newBoothUpdated;
    } else {
      var boothToBeUpdated = booths.filter(
        (booth) => booth.locationid === activeBooth.locationid
      )[0];
      if (boothToBeUpdated && !objectIsEmpty(boothToBeUpdated)) {
        var newBoothUpdated = { ...boothToBeUpdated, color: activeBooth.color };
        var index = _.findIndex(booths, {
          locationid: boothToBeUpdated.locationid,
        });
        booths.splice(index, 1, newBoothUpdated);
      }
    }
  }

  return {
    session: state.session,
    toAddNewBooth,
    activeBooth,
    boothToBeAdded,
    selectedMap: state.selectediMap,
    image: { src: imageSrc },
    changeMapImage: state.changeMapImage,
    progress: state.imapUploadProgress,
    uploadInProcess:
      state.imapUploadProgress &&
      state.imapUploadProgress >= 0 &&
      state.imapUploadProgress < 100,
    uploadFailed: state.imapImageUploadFailed,
    uploadedImage: state.imapImageUploadedData,
    booths,
  };
}

export default connect(mapStateToProps, {
  addNewBooth,
  addInteractiveMapName,
  mapImageChanged,
  uploadNewiMapImage,
  imapImageToUpload,
  startFileUpload,
  addBoothData,
  closeBooth,
})(IMap);
